module.exports = __webpack_public_path__ + "img/banner-Ba.1665f1f1.png";